export const helpKey = 'A430538626294D82A5F51FF2B8AAF2FA';
export const supportKey = '0C68E919C367424CB4CBC49DE582771E';
